import React from "react";
import { motion } from "framer-motion";

const overlayClassName =
  "fixed inset-0 z-[1000] flex items-center justify-center bg-black/45";

function ModalOverlay({ children, className = "" }) {
  return (
    <motion.div
      className={`${overlayClassName} ${className}`.trim()}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2 }}
    >
      {children}
    </motion.div>
  );
}

export default ModalOverlay;
